import React from 'react';
import { Ownership } from '../../types/types';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, useTheme } from '@mui/material';

export interface Props {
    ownership: Ownership;
}

function OwnershipTooltipPopover({ownership}:Props) {
    return (<Paper style={{padding: "0.5rem"}}>
    <h2>Ownership</h2>
    <Table size="small">
        <TableHead>
            <TableRow>
                <TableCell>Top N Teams</TableCell>
                <TableCell>% Own</TableCell>
            </TableRow>
        </TableHead>
        { ownership?.round !== 0 ?
        <TableBody>
            <TableRow>
                <TableCell>100</TableCell>
                <TableCell>{ownership?.top100}%</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>1,000</TableCell>
                <TableCell>{ownership?.top1000}%</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>5,000</TableCell>
                <TableCell>{ownership?.top5000}%</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>10,000</TableCell>
                <TableCell>{ownership?.top10000}%</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>20,000</TableCell>
                <TableCell>{ownership?.top20000}%</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>100,000</TableCell>
                <TableCell>{ownership?.top100000}%</TableCell>
            </TableRow> 
        </TableBody> : <TableBody>
            <TableCell>Pre Season</TableCell>
            <TableCell>{ownership?.top100}%</TableCell>
        </TableBody>}
    </Table>
    </Paper>)
}

export default OwnershipTooltipPopover